import { Component } from '@angular/core';
import {
  AbstractWorkLogMsg,
  CalcCoverageLog,
  CalcImpactAssessmentLog,
  CalcPerformanceLog,
  CalcProcedurePerfLog,
  CalcSectorizationLog,
  CumulativeCoverageLog,
  NavLocAssessLog,
  TerrainAltitudeCutLog
} from 'src/app/models/calcConfigInfo';
import { CalculationSettingsModel, RNAVModel } from 'src/app/models/configuration';
import { CalculationsService } from 'src/app/services/calculations.service';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { ProjectService } from 'src/app/services/project.service';
import { TabsService } from 'src/app/services/tabsService';
import { ConfigurationTerrain } from 'src/app/models/terrains';
import {DeviceSectorization, DeviceSectorizationType} from "../../models/grit/grit.device-model";

@Component({
  selector: 'app-calculation-configuration',
  templateUrl: './calculation-configuration.component.html',
  styleUrls: ['./calculation-configuration.component.scss'],
  standalone: false
})


export class CalculationConfigurationComponent{

  public readonly COVERAGE = CalcCoverageLog;
  public readonly PERFORMANCE = CalcPerformanceLog;
  public readonly PROCEDURE_ANALYSIS = CalcProcedurePerfLog;
  public readonly DOC_AND_SEC = CalcSectorizationLog;
  public readonly CUMULATIVE_COVERAGE = CumulativeCoverageLog;
  public readonly NAVAID_SITING_TOOL = NavLocAssessLog;
  public readonly TERRAIN_ALTITUDE_CUT = TerrainAltitudeCutLog;

  //#region GRIT
  public readonly IMPACT_ASSESSMENT = CalcImpactAssessmentLog;
  //endregion

  public readonly  PROPAGATION_TYPE_OPTIONS = [ "Line of sight", "Diffraction (Knife-Edge model)",
  "Diffraction (60% simplification)" ];
  public readonly VISIBILITY_SCALING_OPTIONS = ["3x2 area (Default)", "1x1 area (No scaling)", "2x2 area", "3x3 area", "4x4 area"];
  public readonly AZIMUTH_OPTIONS = CalculationSettingsModel.AZIMUTH_OPTIONS;
  public readonly SECTOR_LENGTH_OPTIONS = CalculationSettingsModel.SECTOR_LENGTH_OPTIONS;
  public readonly VISIBILITY_GRANULARITY_OPTIONS = CalculationSettingsModel.VISIBILITY_GRANULARITY_OPTIONS;
  public readonly FACILITY_ELEVATION_OPTIONS = CalculationSettingsModel.FACILITY_ELEVATION_OPTIONS;
  public readonly COVERAGE_ALGORITHM_OPTIONS = CalculationSettingsModel.COVERAGE_ALGORITHM_OPTIONS;
  public readonly CALCULATION_TYPE_OPTIONS = ["Multi DME", "Multi VOR/DME"];
  public readonly SUBTENDED_ANGLE_OPTIONS = RNAVModel.SUBTENDED_ANGLE_OPTIONS;

  constructor(
    public calculationsService: CalculationsService,
    public tabsService: TabsService,
    public projectService: ProjectService,
    public configService: ConfigurationService
    ) {
     }

  parseInt(number: string): number{
    return Number.parseInt(number);
  }

  isInstance(type): boolean{
    return this.calculationsService.calcInfo instanceof type;
  }

  getDTO(){
    if (this.calculationsService.calcInfoDTO){
      return this.calculationsService.calcInfoDTO;
    }
    if (this.isInstance(this.COVERAGE) || this.isInstance(this.CUMULATIVE_COVERAGE) || this.isInstance(this.DOC_AND_SEC)){
      return (this.calculationsService.calcInfo as any).coverageDTO;
    } else if (this.isInstance(this.PERFORMANCE)){
      return (this.calculationsService.calcInfo as any).performanceDTO;
    } else if (this.isInstance(this.PROCEDURE_ANALYSIS)){
      return (this.calculationsService.calcInfo as any).performanceAnalysisDTO;
    } else if (this.isInstance(this.TERRAIN_ALTITUDE_CUT)){
      return (this.calculationsService.calcInfo as any).terrainAltitudeCutDTO;
    }
    //#region GRIT
    else if (this.isInstance(this.IMPACT_ASSESSMENT)) {
      return (this.calculationsService.calcInfo as any).calculationImpactAssessmentDTO;
    }
    //endregion
  }

  getTerrainsOfType(type: string): ConfigurationTerrain[]{
    const toReturn: ConfigurationTerrain[] = [];
    if (!this.configService.terrainTypes){
      return toReturn;
    }
    const terrainTypeId: number = this.configService.terrainTypes.find(terrainType => terrainType.type.toUpperCase() == type.toUpperCase()).id;
    for (const terrain of this.calculationsService.calcInfo.terrains){
      terrain.terrainTypeId == terrainTypeId? toReturn.push(terrain): false;
    }
    return toReturn;

  }

  protected readonly DeviceSectorizationType = DeviceSectorizationType;
  protected readonly DeviceSectorization = DeviceSectorization;
}
